import { memo } from "react";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const BankingAndFinanceLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.Merchant].BankingAndFinance}`}
        Icon={AccountBalanceIcon}
        {...props}
    >
        Banking & Finance
    </StepLabel>
);

export default memo(BankingAndFinanceLabel);
